// 接送机包车相关API
import request from '../utils/request';
import { createNonceStr, md5, getLocationSearch } from '../utils/utils';

// API路径定义
export const orderSelectApi = '/api/fly/order/select'; // 抢单大厅列表
export const orderRecordApi = '/api/fly/order/record'; // 接单记录
export const orderGrabApi = '/api/fly/order/grab'; // 抢单接口
export const orderCompleteApi = '/api/fly/order/complete'; // 完成订单
export const orderUpdateApi = '/api/fly/order/update'; // 更新订单状态
export const orderTodayApi = '/api/fly/order/today'; // 今日数据
export const getAllByDriverId = '/api/im/getAllByDriverId';//获取聊天记录列表
export const getByOrderIdApi = '/api/im/getByOrderId'; // 根据订单号获取聊天记录
export const isChatApi = '/api/im/isChat'; // 判断订单是否能发送消息
export const pushDriverMsgApi = '/api/im/pushDriverMsg'; // 司机发送IM消息
export const driverAlreadyReadMsgApi = '/api/im/driverAlreadyReadMsg'; // 消息已读
export const fileUpload = '/api/file/upload'; // 文件上传

/**
 * 获取请求签名参数
 * @returns {Object} 包含签名的请求参数
 */
export function getSignParams() {
  let token = getLocationSearch().token|| localStorage.getItem("userToken") || "";
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  
  return {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign
  };
}

/**
 * 获取抢单大厅列表
 * @param {Object} params - 请求参数
 * @param {number} params.orderStatus - 订单状态 1-呼叫中
 * @param {number} params.pageNo - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export function getOrderList(params) {
    
    const signParams = getSignParams();
    const token = signParams.token;
    return request.post(orderSelectApi, { ...params, token }, signParams);
}

/**
 * 获取接单记录
 * @param {Object} params - 请求参数
 * @param {number} params.pageNo - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise}
 */
export function getOrderRecord(params) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderRecordApi, { ...params, token }, signParams);
}


/**
 * 抢单
 * @param {string} orderId - 订单ID
 * @returns {Promise}
 */
export function grabOrder(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderGrabApi, { orderId, orderStatus: "2", token }, signParams);
}

/**
 * 完成订单
 * @param {string} orderId - 订单ID
 * @returns {Promise}
 */
export function completeOrder(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderCompleteApi, { orderId, token }, signParams);
}

/**
 * 更新订单状态
 * @param {string} orderId - 订单ID
 * @param {string} orderStatus - 订单状态：2-接驾中, 3-司机到达上车点, 4-乘客上车, 5-已完成
 * @returns {Promise}
 */
export function updateOrderStatus(orderId, orderStatus) {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.post(orderUpdateApi, { orderId, orderStatus, token }, signParams);
}

/**
 * 获取今日数据
 * @returns {Promise} 返回今日完单、今日收入、待处理订单数据
 */
export function getTodayData() {
  const signParams = getSignParams();
  const token = signParams.token;
  
  return request.get(orderTodayApi, { token }, signParams);
}

/**
 * 获取聊天记录列表
 * @returns {Promise} 返回聊天记录列表
 */
export function getChatList(params) {
  const signParams = getSignParams();
  const token = signParams.token;

  return request.post(getAllByDriverId, { token, ...params }, signParams);
}

/**
 * 根据订单号获取聊天记录
 * @param {string} orderId - 订单ID
 * @returns {Promise} 返回该订单的聊天记录
 */
export function getChatByOrderId(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;

  return request.post(getByOrderIdApi, { orderId, token,pageNo:1,pageSize:10000 }, signParams);
}

/**
 * 判断当前订单是否能发送消息
 * @param {string} orderId - 订单ID
 * @returns {Promise} 返回是否能发送消息
 */
export function isOrderChatEnabled(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;

  return request.get(`${isChatApi}/${orderId}`, { token }, signParams);
}

/**
 * 司机发送IM消息
 * @param {Object} params - 消息参数，如 { orderId, content, ... }
 * @returns {Promise} 返回发送结果
 */
export function pushDriverMsg(params) {
  const signParams = getSignParams();
  const token = signParams.token;

  return request.post(pushDriverMsgApi, { ...params, token }, signParams);
}

/**
 * 司机消息已读
 * @param {Object} params - 参数 { msgIds: [], orderId: "" }
 * @returns {Promise} 返回已读结果
 */
export function driverAlreadyReadMsg(params) {
  const signParams = getSignParams();
  const token = signParams.token;

  return request.post(driverAlreadyReadMsgApi, { ...params, token }, signParams);
}

/**
 * 文件上传
 * @param {File} file - 要上传的文件
 * @param {string} fileType - 文件类型
 * @returns {Promise} 返回上传结果
 */
export function uploadFile(file, fileType) {
  const signParams = getSignParams();
  const token = signParams.token;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', fileType);
  formData.append('token', token);

  return request.post(fileUpload, formData, signParams, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

/**
 * 根据订单号查未读消息数
 * @param {string} orderId - 订单ID
 * @returns {Promise} 返回未读消息数
 */
export function getUnreadMsgCountByOrderId(orderId) {
  const signParams = getSignParams();
  const token = signParams.token;

  return request.get(`/api/im/unRead/${orderId}`, { token }, signParams);
}

